export class SetJobUserViewStatus {
    public static readonly type = '[JobsPlacements] Set job user view status';

    constructor(public jobId: number) {}
}
